import { Radar, Wand2, Send, MessagesSquare, Target, Gauge, Film, Users, Crown } from "lucide-react";

export const GIULIA_POLES = [
  { n: "01", icon: Radar, title: "Veille", text: "Surveillance des concurrents (Instagram, TikTok, Facebook, LinkedIn), score viral (posts ×5 à ×20 la normale), palmarès du jour, veille des pubs concurrentes et des tendances." },
  { n: "02", icon: Wand2, title: "Création", text: "Brand kit, voix de la marque qui apprend, scripts seconde par seconde, contenu décliné sur tous les formats, vidéos UGC IA, influenceur/mascotte IA, pubs statiques, packshots et vidéos cinématiques." },
  { n: "03", icon: Send, title: "Diffusion", text: "Calendrier éditorial, validation client en 1 clic, publication programmée et test de pubs en volume." },
  { n: "04", icon: MessagesSquare, title: "Capture & réponse", text: "Réponse instantanée aux leads, appel manqué → SMS automatique, chatbot sur le site et agent vocal 24/7." },
  { n: "05", icon: Target, title: "Conversion", text: "Prise de rendez-vous avec rappels, relance des anciens clients et devis non signés, avis Google automatiques." },
  { n: "06", icon: Gauge, title: "Pilotage", text: "Tableau de bord, rapport mensuel + débrief humain, et un chat avec Giulia : « fais-moi 10 pubs pour Noël »." },
];

export const GIULIA_PACKS = [
  { icon: Film, name: "Giulia Contenu", text: "Veille + scripts + calendrier + vidéos et visuels IA chaque mois." },
  { icon: Users, name: "Giulia Clients", text: "Capture + réponse 24/7 + prise de RDV + relances + réputation." },
  { icon: Crown, name: "Giulia Complète", text: "Les 6 pôles réunis + débrief mensuel avec Pépé.", flagship: true },
];

export const GIULIA_ENGAGEMENTS = [
  "Rien n'est publié sans votre validation.",
  "Les contenus IA sont identifiés comme tels.",
  "Vos données sont isolées par client (RGPD).",
  "On s'engage sur des actions concrètes, pas sur des promesses.",
];
